<div class="container p-0 overflow-auto add-new-card-modal">
  <div class="header d-flex flex-row">
    <h6 class="fw-bold font-size-14 mb-0">{{ 'new.card.form.title' | translate }}</h6>
    <button id="close-button" (click)="close()">
      <span class="material-icons-outlined"></span>
    </button>
  </div>
  <div class="content">
    <fgbcl-top-up-address
      [hidden]="hasSubmittedMemberAddressFormSuccess"
      (submittedAddress)="handleSubmitAddressForm()"
    ></fgbcl-top-up-address>
    <!-- Loading -->
    <ng-container *ngIf="loading">
      <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
    </ng-container>
    <div id="payment-gateway-area"></div>
    <div *ngIf="hasSubmittedMemberAddressFormSuccess" class="payment-action-buttons">
      <button id="close-button" class="btn text-danger w-50 fw-bold" (click)="close()">
        {{ 'fgbcl.add.new.card.cancel' | translate }}
      </button>
    </div>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="loading-container">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
